import RecoverStep from "../recover_step";
import {startRunbook, voErrorClick} from "../../utils/recover_utils";
import {AJAX_DATA_TYPE_JSON} from "../../utils/recover_consts";
import {convertAutoStopValueToMinutes} from "../../../../modules/helpers/vo-helper";

const TEMPLATE = 'virtualization-runbook';

export default class SetVirtualizationRunbook extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        if (data.recovery.virtualization.useRunbook === undefined) {
            data.recovery.virtualization.useRunbook = true;
        }

        data.render.contentLoaded = false;
        $.ajax({
            type: "GET",
            url: "/client/get_client_runbooks/" + data.clientId + '/' + data.type + '/' + (data.applianceId ? data.applianceId : 0),
            dataType: AJAX_DATA_TYPE_JSON,
            contentType: "application/json",
            success: function(response) {
                if (response.is_error) {
                    fr.defaultAJAXErrorHandler();

                } else {
                    data.render = {
                        contentLoaded: true,
                        useRunbook: data.recovery.virtualization.useRunbook,
                        type: data.recovery.virtualization.type,
                        runbooks: response,
                        hasRunbooks: response.length > 0,
                        hasOnlyOneRunbook: response.length === 1,
                    };
                    fr.render('setVirtualizationRunbook');
                }
            }
        }).fail(fr.defaultAJAXErrorHandler);
    }


    postRender(data, el, fr) {
        const $el = $(el);
        const failover_runbook_button = document.getElementById("hotsite_failover_use_runbook_btn");
        if (failover_runbook_button) {
          failover_runbook_button.disabled = true;
        }
        alignHeaderOnLimitedHeightTable($el);

        if($el.find('tbody tr.trow.selected').length !== 1) {
            if (failover_runbook_button) {
              failover_runbook_button.disabled = true;
            }
        }

        $el.find('#hotsite_failover_use_runbook').click(function() {
            data.recovery.virtualization.useRunbook = true;
            $('#hotsite_failover_dont_use_runbook_btn').addClass('hidden');
            $('#hotsite_failover_use_runbook_btn').removeClass('hidden');
            if (failover_runbook_button)  {
              failover_runbook_button.disabled = false;
            }
        });

        $el.find('#hotsite_failover_dont_use_runbook').click(function() {
            data.recovery.virtualization.useRunbook = false;
            $('#hotsite_failover_use_runbook_btn').addClass('hidden');
            if (failover_runbook_button) {
              failover_runbook_button.disabled = true;
            }
            $('#hotsite_failover_dont_use_runbook_btn').removeClass('hidden');
        });

        $el.find('tbody tr').on('click', function() {
          const isPasswordProtectedRunbook = $(this).data('has-password');
          const masterPasswordBlock = $(this).parents().find('.runbook-master-password-block');
          if (isPasswordProtectedRunbook) {
            masterPasswordBlock.removeClass('invisible');
          } else {
            masterPasswordBlock.addClass('invisible');
          }
          if (data.recovery.virtualization.useRunbook) {
            $(this).parent().find('tr.selected').removeClass('selected');
            $(this).addClass('selected');
            if (failover_runbook_button) {
              failover_runbook_button.disabled = false;
            }
          }
        });

        $el.find('.create_new_runbook a').click(function() {
            data.recovery.virtualization.createRunbook = true;
            fr.close();
            tabs_goto('client/runbooks/' + data.clientId + '/' + data.recovery.virtualization.createRunbook, 'li.clients-tab');
        });

        $('.error-detail a').click(function() {voErrorClick($(this), fr);});
    }

    transitionStart(data, el, fr) {
        const hasPassword = $(el).find('tr.selected').data('hasPassword');
        const failover_runbook_button = document.getElementById("hotsite_failover_use_runbook_btn");
        if (failover_runbook_button) {
          failover_runbook_button.disabled = true;
        }
        data.render.selectedRunbook = {
          id: $(el).find('tr.selected').data('id'),
          name: $(el).find('tr.selected').data('name')
        }

        if (hasPassword) {
          data.render.selectedRunbook.password = $(el).parents().find('.runbook-master-password-block input[name="runbook_password"]').val();
          this.verifyRunbookPassword(data, el, fr);
        } else {
          data.render.selectedRunbook.password = null;
          this.checkRunbook(data, el, fr);
        }
    }

    verifyRunbookPassword(data, el, fr) {
      const failover_runbook_button = document.getElementById("hotsite_failover_use_runbook_btn");
      const checkRunbook = this.checkRunbook.bind(this, data, el, fr);
      $.ajax({
        url      : '/runbook/actions/verify_runbook_password',
        type     : 'POST',
        data     : {
          runbook_id: data.render.selectedRunbook.id,
          password: data.render.selectedRunbook.password,
          client_id: data.clientId,
          is_recovery_flow: true
        },
        dataType : 'json',
        success  : function(rv) {
          if (!$.isEmptyObject(rv.validation_errors)) {
            const errorBlock = $(el).parents().find('.error-message');
            errorBlock.find('.error-main').text(rv.validation_errors.title);
            errorBlock.find('.error-detail').text(rv.validation_errors.details.incorrect_runbook_passwords);
            errorBlock.show();

            const exclamation = $('<i class="fa fa-exclamation-circle error"></i>').attr('data-axtooltip-class', 'error')
                .attr('data-axtooltip', rv.validation_errors[data.render.selectedRunbook.id]);
            const input = $(el).parents().find(':input[name="runbook_password"]');
            if (input.length > 0) {
              input.addClass('field-error');
              input.after(exclamation);
            }
            if (failover_runbook_button) {
              failover_runbook_button.disabled = false;
            }
          } else {
            checkRunbook();
          }
        }
      }).fail(fr.defaultAJAXErrorHandler);
    }

    checkRunbook(data, el, fr) {
      const runbookId = data.render.selectedRunbook.id;
      const failover_runbook_button = document.getElementById("hotsite_failover_use_runbook_btn");
      $.ajax({
        url      : '/runbook/actions/check',
        type     : 'POST',
        data     : {
          client_id: data.clientId,
          runbook_id: runbookId,
          vo_type: data.recovery.virtualization.type
        },
        dataType : 'json',
        success  : function(rv, status) {
          const check_result = rv.warnings;
          if (rv.is_error) {
            if (failover_runbook_button) {
              failover_runbook_button.disabled = false;
            }
            $.extend(data.render, {
              hasError : true,
              errors   : rv.errors
            });
          } else if (!(check_result) || (check_result.length === 0)) {
            data.recovery.virtualization.runbook = data.render.selectedRunbook;
            startRunbook(
                fr,
                data.clientId,
                runbookId,
                data.recovery.virtualization.type,
                data.recovery.virtualization.runbook.password,
                convertAutoStopValueToMinutes(data.recovery.virtualization.autoStopValue),
                function(rv, status) {
                  fr.goTo('createRunbookFailover');
                },
                function(rv, status) {
                  if (failover_runbook_button) {
                    failover_runbook_button.disabled = false;
                  }
                  $.extend(data.render, {
                    hasError : true,
                    errors   : rv.errors
                  });
                  fr.render('setVirtualizationRunbook');
                }
            );
          } else {
            data.recovery.virtualization.runbook = data.render.selectedRunbook;
            data.recovery.virtualization.backStep = 'setVirtualizationRunbook';
            data.check_result = rv.warnings;
            fr.goTo('startRunbookWarning');
          }
        }
      }).fail(fr.defaultAJAXErrorHandler);
    }

}
